import request from '@/config/axios'

// 线路套餐 - 平台模式
export const getRoutePackagePage = (params: any) => {
  return request.get({ url: '/scenic/route/package/page', params })
}

export const getRoutePackage = (id: number) => {
  return request.get({ url: '/scenic/route/package/get', params: { id } })
}

export const getRoutePackageListByRouteId = (routeId: number) => {
  return request.get({ url: '/scenic/route/package/list-by-route', params: { routeId } })
}

export const createRoutePackage = (data: any) => {
  return request.post({ url: '/scenic/route/package/create', data })
}

export const updateRoutePackage = (data: any) => {
  return request.put({ url: '/scenic/route/package/update', data })
}

export const deleteRoutePackage = (id: number) => {
  return request.delete({ url: '/scenic/route/package/delete', params: { id } })
}

export const deleteRoutePackageList = (ids: number[]) => {
  return request.delete({ url: '/scenic/route/package/delete-list', params: { ids: ids.join(',') } })
}

export const updateRoutePackageStatus = (id: number, status: number) => {
  return request.put({ url: '/scenic/route/package/update-status', params: { id, status } })
}
